import { Badge } from '@chakra-ui/react';

type UnreadBadgeProps = {
  count: number;
};

export const UnreadBadge = ({ count }: UnreadBadgeProps) => {
  if (!count || count <= 0) return null;

  return (
    <Badge
      colorScheme="red"
      variant="solid"
      borderRadius="full"
      minW="20px"
      h="20px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      fontSize="xs"
      px="2"
    >
      {count > 99 ? '99+' : count}
    </Badge>
  );
};
